import MuiInput from './MuiInput'
import MuiAutocomplete from './MuiAutocomplete'
import MuiRadioGroup from './MuiRadioGroup'
import MuiCheckboxes from './MuiCheckboxes'
import { MuiPasswordField } from './MuiPasswordField'
import { MuiSwitch } from './MuiSwitch'
import { MuiSelect } from './MuiSelect'
import { AntdDatePicker } from './AntdDatePicker'
import { AntdDateRangePicker } from './AntdDateRangePicker'
import MuiButton from './MuiButton'
import MuiUploadImage from './MuiUploadImage'
import RichTextEditor from './RichTextEditor'
import MaterialTable from './MaterialTable'
import PhoneInputField from './PhoneInput'
import FormikReactQuill from './FormikReactQuill'
import ReactQuill from 'react-quill';

function FormikControl(props) {
    const { control, ...rest } = props
    switch (control) {
        case 'textfield':
            return <MuiInput {...rest} />
        case 'autocomplete':
            return <MuiAutocomplete {...rest} />
        case 'radiogroup':
            return <MuiRadioGroup {...rest} />
        case 'checkbox':
            return <MuiCheckboxes {...rest} />
        case 'passwordfield':
            return <MuiPasswordField {...rest} />
        case 'switch':
            return <MuiSwitch {...rest}/>
        case 'select':
            return <MuiSelect {...rest}/>
        case 'datepicker':
            return <AntdDatePicker {...rest} />
        case 'daterangepicker':
            return <AntdDateRangePicker {...rest}/>
        case 'uploadImage':
            return <MuiUploadImage {...rest} />
        case 'button':
            return <MuiButton {...rest}/>
        case 'richTextEditor':
            return <RichTextEditor {...rest}/>
        case 'materialTable':
            return <MaterialTable {...rest}/>
        case 'phoneInputField':
                return <PhoneInputField {...rest}/>
        case 'FormikReactQuill':
                return <FormikReactQuill {...rest}/>
            
        default: return null


    }
}

export default FormikControl